'use strict';
import util from './util';

/**
 * Initializes the widget after the complete page loading
 */
function renderMondialRelayPopup() {
    $("body").addClass("mrelay-scroll-hidden");

    $('.MRW-BtGo').click(function () {
        setTimeout(() => {
          handleMobileListMapView();
          handleAddressDropDownMobile();
          removeDefaultStylingFromMondial();
          updateTextTranslation();
        }, 500);
      });

      if (util.isMobile) {
        setTimeout(() => {
          handleMobileListMapView();
          handleAddressDropDownMobile();
        }, 1000);
      }

      removeDefaultStylingFromMondial();
    
        //Remove default inline style of mondial relay which has !important
    $(".PR-Name").removeAttr("style");
    $(".Tabs-Tab.Tabs-Tab-Selected").removeAttr("style");
    $('.Tabs-Btn.Tabs-Btn-Selected').removeAttr("style");

    $(".mrelay-wrapper").addClass("active");
    $("#Zone_Widget").MR_ParcelShopPicker({
        Target: "#Target_Widget",
        TargetDisplay: "#TargetDisplay_Widget",
        TargetDisplayInfoPR: "#TargetDisplayInfoPR_Widget",
        Brand: window.SitePreferences.ADYEN_ENV_MODE == 'LIVE' ? window.SitePreferences.MR_BRAND['PROD'] : window.SitePreferences.MR_BRAND['TEST'],
        Country: fetchCountryCode(),
        PostCode: fetchPostalCode(),
        City: fetchCity(),
        ColLivMod: "24R",
        NbResults: window.SitePreferences.MR_RESULTS_COUNT,
        ShowResultsOnMap: true,
        DisplayMapInfo: true,
        Responsive: true, 
        OnParcelShopSelected:
            function (data) {
        		$('#TargetDisplayInfoPR_Widget').addClass('hide');
        		$('#selectedStoreName').html(data.Nom);
        		localStorage.setItem('selectedStoreData', JSON.stringify(data));
                removeDefaultStylingFromMondial();
                updateTextTranslation();
                if (util.isMobile) {
                    handleMobileListMapView();
                    handleAddressDropDownMobile();
                  }
            },
    OnNoResultReturned: function () {
      setTimeout(() => {
        const $validPostcodeError = $(".MRW-Errors");
        $validPostcodeError.text() == 'A valid Post Code must be provided in order to use thise widget.' && $validPostcodeError.text(Resources.MONDIAL_VALID_POSTCODE_ERROR);
        $validPostcodeError.text() == 'Sorry, we were not able to find any Point Relais matching your request, you may try again with another postcode near your previous search.' && $validPostcodeError.text(Resources.MONDIAL_NO_RESULT_ERROR);
      }, 500);
    }
    });

    // Widget is getting closed while selecting the store from pickup point list fix
    $(".MRW-ShowList").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
    });

  if ($(".PR-List-Item").hasClass("PR-Selected")) {
    $(".zone_widget_confirm").removeClass("hide");
  }

  // once Zone_Widget get MR-Widget then run the translation function to update the text in the widget as per the locale
  let checkExist = setInterval(function() {
    if ($('#Zone_Widget').find('.MR-Widget').length) { 
        updateTextTranslation();
        clearInterval(checkExist);
    }
  }, 100); // check every 100ms

  $(document).on('click', '.mrelay-wrapper .zone-container #Zone_Widget .MR-Widget .PR-List-Item, .leaflet-marker-icon', function () {  // Required document to attch event as .PR-List-Item is getting refreshed on every click
    setTimeout(() => {
      updateTextTranslation();
    }, 500);
  });
}

function updateTextTranslation() {
    const $title = $(".MRW-Title");
    const $cityLabel = $(".MRW-CityContainer label");
    const $cpLabel = $(".MRW-CPContainer label");
    const $goBtn = $(".MRW-BtGo");
    const $tabsBtns = $(".Tabs-Btns span");

    // Safely update texts if Resources object is available
    $title.text(Resources.MONDIAL_TITLE);
    $cityLabel.text(Resources.MONDIAL_CITY);
    $cpLabel.text(Resources.MONDIAL_POSTALCODE);
    $goBtn.text(Resources.MONDIAL_SEARCH);
    $tabsBtns.eq(0).text(Resources.MONDIAL_OPENINGHOURS);
    $tabsBtns.eq(1).text(Resources.MONDIAL_PHOTO);

    // also translate day names in the opening hours tables (if they exist)
    // only overwrite known keys so that Tuesday etc. can be skipped if desired
    $('.PR-Hours th').each(function () {
        var day = $(this).text().trim().toLowerCase();
        // only replace the days that need dynamic translation
        switch (day) {
            case 'monday':
                $(this).text(Resources.MONDIAL_MONDAY);
                break;
            case 'tuesday':
                $(this).text(Resources.MONDIAL_TUESDAY);
                break;
            case 'wednesday':
                $(this).text(Resources.MONDIAL_WEDNESDAY);
                break;
            case 'thursday':
                $(this).text(Resources.MONDIAL_THURSDAY);
                break;
            case 'friday':
                $(this).text(Resources.MONDIAL_FRIDAY);
                break;
            case 'saturday':
                $(this).text(Resources.MONDIAL_SATURDAY);
                break;
            case 'sunday':
                $(this).text(Resources.MONDIAL_SUNDAY);
                break;

            default:      // do nothing for unrecognized keys to allow flexibility
                break;
        }
    });
}
function removeDefaultStylingFromMondial () {
  //Remove default inline style of mondial relay which has !important
  $(".PR-Name").removeAttr("style");
  $(".Tabs-Tab.Tabs-Tab-Selected").removeAttr("style");
  $('.Tabs-Btn.Tabs-Btn-Selected').removeAttr("style");
}

function handleMobileListMapView() {

    //Replace Numbers of Address for style change
    setTimeout(() => {
      $(".PR-Name").html(function (i, storeNumber) {
        if (!$(this).find(".PR-Name-number").length) {
          storeNumber = storeNumber.replace(' - ', '   ');
          return storeNumber.replace(/(\d+)/g, '<span class="PR-Name-number">$1</span>');
        }
      });
    }, 500);
  
    $(".PR-Name").removeAttr("style");
    $(".Tabs-Tab.Tabs-Tab-Selected").removeAttr("style");
  
    if (!$(".mrelay-view-container").length) {
      $(".MRW-Results").prepend(
        `<div class="mrelay-view-container"><div class="mrelay-listview">${Resources.MONDIAL_TAB_LIST_TEXT}</div><div class="mrelay-mapview">${Resources.MONDIAL_TAB_MAP_TEXT}</div></div>`
      );
      //Default is List View
      $(".mrelay-listview").addClass("active");
    }
  
      //Default View is list view
    if($(".mrelay-mapview").hasClass("active")) {
        $(".MRW-RList").addClass("Hide");
        $('.mrelay-mapview').addClass("active");
        $(".mrelay-listview").removeClass("active");
    } else {
        $(".MRW-RList").removeClass("Hide");
        $('.mrelay-listview').addClass("active");
        $(".mrelay-mapview").removeClass("active");
    }

    setTimeout(() => {
      if (!$(".mrelay-address-dropdown").length) {
        $(".PR-List-Item").append(
          `<div class="mrelay-address-dropdown"><span class="mrelay-dropdown-text">${Resources.MONDIAL_LIST_DROPDOWN_TEXT}</span><span class="icon icon-downCarrot"></span></div>`
        );
      }
    }, 1000);
  
    //Change to List view on click of tab
    $(".mrelay-listview").click(function () {
      $(".MRW-RList").removeClass("Hide");
      $(this).addClass("active");
      $(".mrelay-mapview").removeClass("active");
    });
  
    //Change to Map view on click of tab
    $(".mrelay-mapview").click(function () {
      $(".MRW-RList").addClass("Hide");
      $(this).addClass("active");
      $(".mrelay-listview").removeClass("active");
    });
  }

    // To append the schedule time from the map to the list view on click of 'see the schedule' dropdown
function handleAddressDropDownMobile() {
    $(document).on('click','.mrelay-address-dropdown',function (e) {
        e.stopImmediatePropagation();
        if($(".MRW-Map").find(".leaflet-popup-content-wrapper").length) {
            setTimeout(() => {
            if (!$(this).find(".leaflet-popup-content-wrapper").length) {
                    $(".MRW-Map").find(".leaflet-popup-content-wrapper").clone().appendTo($(this));
                    $(this).find("span.icon").toggleClass("icon-upCarrot icon-downCarrot");
            } else if ($(this).find(".leaflet-popup-content-wrapper").length) {
                $(this).find(".leaflet-popup-content-wrapper").toggle();
                $(this).find("span.icon").toggleClass("icon-downCarrot icon-upCarrot");
            }
            }, 500);
        }
    });
}

// Confirmation Mondial Relay Popup
function confirmationMondialRelayPopup() {
    var checkoutShipping = $(".checkout-shipping").find('[name$="_addressFields_setdefault"]');
    $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
    $('.zone_widget_confirm').addClass('hide');

    if ($(checkoutShipping)) {
        $(".checkout-shipping").find(".setdefault").prop("checked", true);
    }

    localStorage.setItem('storeDetailsSection', $(".store-details-section").html());
}

// Close Mondial Relay Popup 
function closeMondialRelayPopup() {
    $("body").removeClass("mrelay-scroll-hidden");
    $(".mrelay-wrapper").removeClass("active");
}

function fetchPostalCode() {
    var postalCode = '';
    if ($('.address-tile').length > 0) {
        if ($(".store-address-edit").hasClass("edit-btn-active") && localStorage.getItem("selectedStoreData")) {
            $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            var selectedStoreData = JSON.parse(localStorage.getItem("selectedStoreData"));
            postalCode = selectedStoreData.CP;
        } else {
            postalCode = $('.address-tile.selected').find('.mini-address-wrapper').data('postalCode');
        }
    } else {
        postalCode = $('.input-text.postal').val();
    }
    return postalCode;
}

function fetchCity() {
    var city = '';
    if ($('.address-tile').length > 0) {
        if ($(".store-address-edit").hasClass("edit-btn-active") && localStorage.getItem("selectedStoreData")) {
            $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            var selectedStoreData = JSON.parse(localStorage.getItem("selectedStoreData"));
            city = selectedStoreData.Ville;
        } else {
            city = $('.address-tile.selected').find('.mini-address-wrapper').data('city');
        }
    } else {
        city = $('.input-text.city').val();
    }
    return city;
}

function fetchCountryCode() {
    var countryCode = '';
    if ($('.address-tile').length > 0) {
        if ($(".store-address-edit").hasClass("edit-btn-active") && localStorage.getItem("selectedStoreData")) {
            $('.store-address-edit, .address-pin-icon, .store-details-wrapper').removeClass('hide');
            var selectedStoreData = JSON.parse(localStorage.getItem("selectedStoreData"));
            countryCode = selectedStoreData.Pays;
        } else {
    	    countryCode = $('.address-tile.selected').find('.mini-address-wrapper').data('country-code').toUpperCase();
        }
    } else {
        countryCode = $('#dwfrm_singleshipping_shippingAddress_addressFields_country').val();
    }
    return countryCode;
}

function matchMRSelectedCountryCode() {
	
	 var selectedStoreData = localStorage.getItem("selectedStoreData");
	 var formContryCode= fetchCountryCode();
	 var countryCodeMond = '';
 	if(selectedStoreData) {
 		selectedStoreData = JSON.parse(selectedStoreData);
 		countryCodeMond = selectedStoreData.Pays;
 	}
 		
 		
	return (countryCodeMond === formContryCode || $('#pickupStore_storeAddressCountry').val() === formContryCode);
}

export default {
  renderMondialRelayPopup: renderMondialRelayPopup,
  confirmationMondialRelayPopup: confirmationMondialRelayPopup,
  closeMondialRelayPopup: closeMondialRelayPopup,
  matchMRSelectedCountryCode: matchMRSelectedCountryCode
};